module.exports = __webpack_public_path__ + "static/media/weekly.8a312ed5.png";